import { ui, dia } from "@joint/plus";
import { ProceduresService } from "../../services/procedures/procedures.service";
import { Observable } from "rxjs";



export function getPdfBlob(procedureId: string, paperScroller: ui.PaperScroller, paper:  dia.Paper, proceduresService: ProceduresService): Observable<any> {

  // On définit le width maximum du paper qui correspond au width du paper dans le logigramme service
  const maxPaperWidth = 800;

  // On récupère le zoom courant
  let currentZoom = paperScroller.zoom();
  // On part du principe que le zoom initial est 1 donc pour revenir au zoom de base il faut soustraire ce que l'utilisateur a zoomé.
  paperScroller.zoom(1 - currentZoom);

  // On récupère le height et le width du logigramme pour les utiliser dans la div englobante
  // Si un height et un width sont bien présent, on les prend, sinon ça sera en height et width = 100%.
  let logigrammeHeight = paper.options.height ? +paper.options.height : 0;
  let logigrammeWidth = (paper.options.width && +paper.options.width < maxPaperWidth ) ? +paper.options.width : maxPaperWidth;
  let logigrammeHeightString = paper.options.height ? paper.options.height + 'px' : '100%';
  let logigrammeWidthString = paper.options.width ? maxPaperWidth + 'px' : '100%';


  // On met la couleur des pages breaks en blanc pour la génération du PDF. On la remet en couleur initiale aprés la génération
  let whiteStrokeColorHex: string = "#FFFFFF";
  setPageBreaksColorAttribute(paper.layers.children, whiteStrokeColorHex);

  // On encapsule dans une div en position : relative, car le svg est en position absolute et sera donc au-dessus de la page de garde.
  let logigrammeContainerStart = `<div style='position: relative;width: ${logigrammeWidthString}; height: ${logigrammeHeightString};'>`;
  let logigrammeContainerContent = paper.svg.outerHTML ? paper.svg.outerHTML : '';
  let logigrammeContainerEnd = "</div>";

  let logigrammeHtml = logigrammeContainerStart + logigrammeContainerContent  + logigrammeContainerEnd;

  let id = procedureId.toString();
  return proceduresService.generatePdf(id, logigrammeHtml, logigrammeHeight, logigrammeWidth);
}


// Methode privée qui cherche les balises "path" des breaks point pour pouvoir leur changer de couleur.
function setPageBreaksColorAttribute(layerChildren: HTMLCollection, color: string) {
  let firstElementOfLayer = layerChildren.item(0);
  if(firstElementOfLayer && firstElementOfLayer.nodeName == "path") {
    firstElementOfLayer.setAttribute("stroke", color);
  }
}

